import * as api from '@/api/give-course/vote'
import * as TYPES from './type';

export default {
  //投票添加
  async postSKVoteAdd({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKVoteAdd(paramets)
    commit(TYPES.SK_VOTE_ADD, { result })
    cb && cb()
  },
  //投票添加
  async getSKVoteDetail({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKVoteDetail(paramets)
    commit(TYPES.SK_VOTE_DETAIL, { result })
    cb && cb()
  },
  //投票选项
  async getSKVoteOpts({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKVoteOpts(paramets)
    commit(TYPES.SK_VOTE_OPTS, { result })
    cb && cb()
  },
}
